export default "__VITE_PUBLIC_ASSET__15b27c48__"